import { useEffect } from "react";
import { Toast } from "../helpers/alert";
import { logoutUser, session } from "../redux/apiCalls/loginCall";

const useSessionValidation = (user, dispatch, navigate, lastClickTime) => {
  useEffect(() => {
    const validateTokenOnLoad = () => {
      const currentTime = Math.floor(Date.now() / 1000);
      const tokenExpiration = user.currentUser?.exp;

      if (!user.currentUser?.accessToken || currentTime >= tokenExpiration) {
        Toast.fire({
          icon: "info",
          title: "Su sesión ha expirado. Por favor, inicie sesión nuevamente.",
        });
        logoutUser(dispatch);
        navigate("/login");
      }
    };

    validateTokenOnLoad();
  }, [user.currentUser, dispatch, navigate]);

  useEffect(() => {
    if (!user.currentUser?.accessToken && !user.currentUser) {
      navigate("/login");
    } else if (user.currentUser?.passwordExpired === true) {
      navigate("/expired-password");
    }
  }, [user.currentUser, navigate]);

  useEffect(() => {
    if (!user?.currentUser?.accessToken) return;

    const interval = setInterval(() => {
      const currentTime = Math.floor(Date.now() / 1000);
      const rest = user.currentUser?.exp - currentTime;
      const timeDifference = Date.now() - lastClickTime;

      if (timeDifference >= 8.5 * 60 * 1000) {
        Toast.fire({
          icon: "info",
          timer: 60000,
          didOpen: (toast) => {
            toast.addEventListener("click", () => {
              Toast.close();
            });
          },
          title: "Su sesión finalizará en breve por falta de actividad. De click a este mensaje si quiere mantenerse logueado.",
        });
      }

      if (rest <= 0 || timeDifference >= 10 * 60 * 1000) {
        Toast.fire({
          icon: "info",
          timer: 5000,
          title: "Por razones de seguridad, su sesión ha sido cerrada. Por favor Iniciar sesión.",
        });

        logoutUser(dispatch, user.currentUser?.accessToken, {
          user: user.currentUser?.user,
        });
        navigate("/login");
      } else if (rest < 2 * 60 && rest > 1) {
        session(dispatch, user, user.currentUser?.accessToken);
      }
    }, 30000);

    return () => clearInterval(interval);
  }, [lastClickTime, user, dispatch, navigate]);
};

export default useSessionValidation;
